export default __webpack_public_path__ + "static/media/SWT0280.34I-26915_-16386_0.5c66b06c.jpg";